//Game types
export const CONTENT_TYPES = {
  G_3MIN: 'G_3MIN',
  G_24HR: 'G_24HR',

  LANDING: 'landing',
  LVG_AI_INDEXES: 'lvg-ai_indexes',
  LVG_CRYPTO: 'lvg-crypto',
  LVG_STOCKS: 'lvg-stocks',
  LVG_INDEXES: 'lvg-indexes',
  G_BUSTED: 'busted',
  WALLET: 'wallet',
  RESTRICTED: 'restricted',
  REFERRALS: 'referrals',
  YOLO_TOKEN: 'yolo_token',
  PRIVATE_PRESALE: 'private_presale',
  PUBLIC_PRESALE: 'public_presale',
  ACHIEVEMENT: 'achievements',
}
